app.controller('TranslateController', [
    "$translate", "$scope",
    function ($translate, $scope) {

        $scope.filteredLanguages = [];

        $scope.languages = {
            'ka': {
                code: 'ka',
                img: 'img/Flag_Georgia.png',
            },
            'en': {
                code: 'en',
                img: 'img/Flag_United_Kingdom.png'
            }
        };

        $translate.onReady(function () {
            var savedLang = localStorage.getItem('lang')
            if(savedLang){
                $scope.current = $scope.languages[savedLang];
            } else {
                $scope.current = $scope.languages[$translate.preferredLanguage()];
            }
            $scope.applyChangesToFiltered();
        });

        $scope.changeLanguage = function (langKey) {
            $translate.use(langKey);
            $scope.current = $scope.languages[langKey];
            $scope.applyChangesToFiltered();
            localStorage.setItem('lang', langKey);
        };

        $scope.applyChangesToFiltered = function () {
            var langs = Object.keys($scope.languages).map(function (key) {
                return $scope.languages[key];
            });
            $scope.filteredLanguages = langs.filter(function (ln) {
                return ln.code != $scope.current.code;
            });
        }
    }
]);